import { defineMessages } from 'react-intl';

export default defineMessages({
    coverages: {
        id: 'ml.quoteandbind.hoeditcoverages.coverages',
        defaultMessage: 'Coverages'
    },
    policyTypeMsg: {
        id: 'ml.quoteandbind.hoeditcoverages.policyTypeMsg',
        defaultMessage: 'This is a snapshot of the coverages, limits and premium for your {policyType} policy. Coverage can be customized.'
    },
    optionalCoverages: {
        id: 'ml.quoteandbind.hoeditcoverages.optionalCoverages',
        defaultMessage: 'Optional Coverages'
    },
    vpp: {
        id: 'ml.quoteandbind.hoeditcoverages.vpp',
        defaultMessage: 'Valuable Personal Property'
    },
    mineSubSchedItemLabel: {
        id: 'ml.quoteandbind.hoeditcoverages.mineSubSchedItemLabel',
        defaultMessage: 'Mine Subsidence Insurance - Scheduled Private Structure'
    },
    editCoverage: {
        id: 'ml.quoteandbind.hoeditcoverages.editCoverage',
        defaultMessage: 'Edit Coverage'
    },
    spp: {
        id: 'ml.quoteandbind.hoeditcoverages.spp',
        defaultMessage: 'Scheduled Personal Property'
    },
    exclusions: {
        id: 'ml.quoteandbind.hoeditcoverages.exclusions',
        defaultMessage: 'Exclusions'
    },
    covTotal: {
        id: 'ml.quoteandbind.hoeditcoverages.covTotal',
        defaultMessage: 'Coverage Total'
    },
    covTooltip: {
        id: 'ml.quoteandbind.hoeditcoverages.covTooltip',
        defaultMessage: 'The premium shown does not include fees or taxes'
    },
    perYear: {
        id: 'ml.quoteandbind.hoeditcoverages.perYear',
        defaultMessage: '/year'
    },
    limits: {
        id: 'ml.quoteandbind.hoeditcoverages.limits',
        defaultMessage: 'Limits'
    },
    premium: {
        id: 'ml.quoteandbind.hoeditcoverages.premium',
        defaultMessage: 'Premium'
    },
});
